export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10452.f760625e.jpg";